import React, { createContext, useContext, useMemo } from 'react';
import { useSetAtom } from 'jotai';
import { imageZoomAtom } from './imageZoomAtom';

/** 이미지 "크게보기" 트리거 컨텍스트 */
export type ImageZoomTrigger = (src: string) => void;

const ImageZoomContext = createContext<ImageZoomTrigger | null>(null);

type ImageZoomProviderProps = {
  children: React.ReactNode;
};

/** 트리거를 value 로 내려주는 Provider — imageZoomAtom 을 open+src 로 set */
export const ImageZoomProvider = ({ children }: ImageZoomProviderProps) => {
  const setImageZoom = useSetAtom(imageZoomAtom);

  const trigger = useMemo<ImageZoomTrigger>(
    () => (src: string) => {
      if (!src) return;
      setImageZoom({ open: true, src });
    },
    [setImageZoom],
  );

  return (
    <ImageZoomContext.Provider value={trigger}>
      {children}
    </ImageZoomContext.Provider>
  );
};

/** zoom Provider 하위면 trigger, 밖이면 null — null 이면 호출처가 img 클릭 미부착(회귀 방지). */
export const useImageZoomTrigger = (): ImageZoomTrigger | null =>
  useContext(ImageZoomContext);
